// Surface materials (§3) — kept to three across all levels:
//   grass : default baseline
//   ice   : much faster, very slippery (the fast line)
//   mud   : slower, sticky (the slow zone)
// Authored as data so designers tweak feel without touching physics code.

export type SurfaceId = 'grass' | 'ice' | 'mud';

export interface SurfaceMaterial {
  id: SurfaceId;
  label: string;
  frictionMultiplier: number;
  gripMultiplier: number;
  maxSpeedMultiplier: number;
  color: number;
}

export const SURFACES: Record<SurfaceId, SurfaceMaterial> = {
  grass: {
    id: 'grass',
    label: 'Grass',
    frictionMultiplier: 1.0,
    gripMultiplier: 1.0,
    maxSpeedMultiplier: 1.0,
    color: 0x5fae54,
  },
  ice: {
    id: 'ice',
    label: 'Ice',
    frictionMultiplier: 0.35,
    gripMultiplier: 0.4,
    maxSpeedMultiplier: 1.5, // the fast line
    color: 0xbfe9f5,
  },
  mud: {
    id: 'mud',
    label: 'Mud',
    frictionMultiplier: 1.9,
    gripMultiplier: 1.2,
    maxSpeedMultiplier: 0.7, // the slow zone
    color: 0x6b4f33,
  },
};

export const getSurface = (id: SurfaceId): SurfaceMaterial => SURFACES[id];
